import React from 'react';
import PropTypes from 'prop-types';
import './ShapeSelect.scss';
import shapes from './shapes';

const ShapeSelect = ({ badgeLabel = null, subtitle = null, ...props }) => {
  const shapeKeys = Array.isArray(props.shape) ? props.shape : [props.shape];

  return (
    <label className={`ShapeSelect${props.selected ? ' selected' : ''}`}>
      <input
        type="radio"
        className="visually-hidden"
        name={props.name}
        value={props.value}
        checked={props.selected}
        onChange={props.onChange}
      />
      {badgeLabel && <div className="default-badge">{badgeLabel}</div>}
      <div className="checkmark-clip" aria-hidden="true">
        <div className="checkmark">
          <i className="material-icons">done</i>
        </div>
      </div>

      <div className="shape-group" aria-hidden="true">
        {shapeKeys.map((shapeKey, index) => (
          <React.Fragment key={shapeKey}>
            {index > 0 && <span className="shape-divider" />}
            <div className="shape">{shapes[shapeKey]}</div>
          </React.Fragment>
        ))}
      </div>

      <div className="shape-label">{props.label}</div>
      {subtitle && <div className="shape-subtitle">{subtitle}</div>}
    </label>
  );
};

export default ShapeSelect;

ShapeSelect.propTypes = {
  selected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  shape: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  label: PropTypes.string.isRequired,
  badgeLabel: PropTypes.string,
  subtitle: PropTypes.string,
};
